import type { NavigationItemDto } from '@accesso/cc-ecomm-api';

export function getPageNameByValue(value: string, navigation: NavigationItemDto[] = []): string {
	for (const item of navigation) {
		if (item.type === 'page-template' && item.value === value) return item.label;
		if (Array.isArray(item.items)) {
			const result = getPageNameByValue(value, item.items);
			if (result) return result;
		}
	}
	return '';
}
